import React from 'react';
import { TableContainer, Paper, TableCell, TableBody } from '@material-ui/core';

import Table from 'react-bootstrap/Table';

const ShowDataTable = ({ columns, rows }) => {
  return (

   <Table hover responsive className='mb-0'>
       <thead className='bg-gray'>
         <tr>
           {columns.map((column, index) => (
             <th key={index}>{column}</th>
           ))}
         </tr>
       </thead>
       <tbody>
         {rows.map((rowData, index) => (
           <tr key={index}>
             {rowData.map((cellData, cellIndex) => (
               <td key={cellIndex}>{cellData}</td>
             ))}
           </tr>
         ))}
       </tbody>
     </Table>

  //  <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
  //    <Table>
  //      <TableHead>
  //        <TableRow style={{ backgroundColor: '#867FA1' }}>
  //          {columns.map((column, index) => (
  //            <TableCell key={index}>{column}</TableCell>
  //          ))}
  //        </TableRow>
  //      </TableHead>
  //      <TableBody>
  //        {rows.map((rowData, index) => (
  //          <TableRow key={index}>
  //            {rowData.map((cellData, cellIndex) => (
  //              <TableCell key={cellIndex}>{cellData}</TableCell>
  //            ))}
  //          </TableRow>
  //        ))}
  //      </TableBody>
  //    </Table>
  //  </TableContainer>
  );
};

export default ShowDataTable;
